import { render, staticRenderFns } from "./TermSearchSlidebar.vue?vue&type=template&id=3c66e080"
import script from "./TermSearchSlidebar.vue?vue&type=script&lang=js"
export * from "./TermSearchSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports